import { useEffect, useRef } from "react";
export function useNativeDialog(open, onClose) {
    const dialogRef = useRef(null);
    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog)
            return;
        if (open && !dialog.open) {
            dialog.showModal();
        }
        else if (!open && dialog.open) {
            dialog.close();
        }
    }, [open]);
    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog)
            return;
        const handleClose = () => onClose();
        const handleBackdropClick = (event) => {
            if (event.target === dialog)
                onClose();
        };
        dialog.addEventListener("close", handleClose);
        dialog.addEventListener("click", handleBackdropClick);
        return () => {
            dialog.removeEventListener("close", handleClose);
            dialog.removeEventListener("click", handleBackdropClick);
        };
    }, [onClose]);
    return dialogRef;
}
